import Keycloak from 'keycloak-js';
import axios from 'axios';
import { useLoginStore } from '@/store/login-store';
import { fetchConfig } from '@/config/app-config'

if (window?.sso == undefined) {
  const sso = window.sso = {}
  sso.isPending = false;
  const HOME = document.location.origin || (process.env.NODE_ENV == 'production' ? 'https://irdr.tjpa.jus.br' : 'https://irdr-dev.apps.oc.i.tj.pa.gov.br/#/?')
  sso.keycloakConfig = {
    logout: {
      redirectUri: process.env.VUE_APP_SSO_REDIRECT_URL || HOME,
    },
    initOptions: {
      flow: 'standard',
      checkLoginIframe: true,
      sessionChecksEnabled: true,
      onLoad: 'check-sso',
      silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
      enableLogging: true,
      redirectUri: process.env.VUE_APP_SSO_REDIRECT_URL || HOME,
    },
    config: {
      url: process.env.VUE_APP_SSO_URL || (process.env.NODE_ENV == 'production' ? 'https://login.tjpa.jus.br/auth' : 'https://irdr-dev.apps.oc.i.tj.pa.gov.br/auth'),
      realm: process.env.VUE_APP_SSO_REALM || 'irdr',
      clientId: process.env.VUE_APP_SSO_CLI_ID || 'irdr-web',
    },
  }

  const startKeycloak = async () => {
    if (sso.isPending) return 
    sso.isPending = true

    const config = await fetchConfig();
    sso.keycloakConfig = {
      logout: {
        redirectUri: process.env.VUE_APP_SSO_REDIRECT_URL || HOME,
      },
      initOptions: {
        flow: 'standard',
        checkLoginIframe: true,
        sessionChecksEnabled: true,
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
        enableLogging: true,
        redirectUri: process.env.VUE_APP_SSO_REDIRECT_URL || HOME,
      },
      config: {
        url: config?.sso?.url || process.env.VUE_APP_SSO_URL || (process.env.NODE_ENV == 'production' ? 'https://login.tjpa.jus.br/auth' : 'https://irdr-dev.apps.oc.i.tj.pa.gov.br/auth'),
        realm: config?.sso?.realm || process.env.VUE_APP_SSO_REALM || 'irdr',
        clientId: config?.sso?.clientId || process.env.VUE_APP_SSO_CLI_ID || 'irdr-web',
      },
    }
    try {
      sso.keycloak = new Keycloak(sso.keycloakConfig.config)
      await sso.keycloak.init(sso.keycloakConfig.initOptions)
    } catch (e) {
      console.error("error loading keycloak on", sso.keycloakConfig.config.url, e)
      sso.keycloak = null
    }
    sso.isPending = false
    return 
  }

  const loadSsoUrlFromApi = async () => {
    if (sso.keycloak) return
    let url = ''
    try {
      const response = await axios.get('/api/sso/url')
      url = response.data
    } catch (e) {
      console.error("error retrieving sso url", e)
      return
    }
    if (url && (keycloakConfig.config.url !== url)) {
      keycloakConfig.config.url = url
      if (sso.keycloak != null) {
        console.warn('Keycloak is not null, trying new connection', sso.keycloak)
        startKeycloak(keycloakConfig)
      }
    }
    return url
  }

  const ssoInterceptor = async (config) => {

    const insertToken = async () => {
      const svcs = await useLoginStore().get(config.url)
      if (svcs.length > 1) console.error("multiple sso services in same request");
      if (svcs.length != 1) return config;

      const svc = svcs[0];

      if (!sso?.keycloak?.authenticated) {
        if (!sso.isPending) return config
      }

      for (let i = 0; i < 3; i++) {

        await new Promise(resolve => setTimeout(resolve, 200));
        if (!sso.isPending) break;
      }

      const addBearer = async (svc) => {
        try {
          const token = await svc.getToken()
          if (token == undefined) throw "got undefined token"
          config.headers.Authorization = `Bearer ${token}`
          config.withCredentials = false;

        } catch (e) {
          // console.error(`Error: ${e}`)
        }
      }

      await addBearer(svc);
      return config;
    }

    await insertToken();

    return config
  }

  sso.ssoInterceptorInstall = (axios) => axios.interceptors.request.use(ssoInterceptor, error => { Promise.reject(error) })

  /* Installs Default token entry */

  const defaultGetToken = async () => {
    for (let i = 0; i < 3; i++) {
      sso.keycloak?.authenticated || await new Promise(resolve => setTimeout(resolve, 200));
    }
    if (!sso.keycloak?.authenticated) return null
    let token = null
    try { token = sso.keycloak?.token; } catch (e) { console.log(e) }
    return token;
  }

  sso.installService = srv => useLoginStore().add(srv)

  const init = () => {
    const loginStore = useLoginStore()
    loginStore.add({ baseUrl: "http://localhost:8080", getToken: defaultGetToken })
    loginStore.add({ baseUrl: "https://irdr-dev.apps.oc.i.tj.pa.gov.br/api", getToken: defaultGetToken })
    loginStore.add({ baseUrl: "https://irdr.tjpa.jus.br/api", getToken: defaultGetToken })
    sso.ssoInterceptorInstall(axios)
  }

  // loadSsoUrlFromApi()
  loadSsoUrlFromApi
  sso.keycloakLoad = startKeycloak(sso.keycloakConfig);
  sso.keycloakPlugin = {
    install: () => {
      init()
      // startKeycloak(keycloakConfig);
    }
  }
}
const sso = window.sso

export const keycloakPlugin = sso.keycloakPlugin
export const keycloakConfig = sso.keycloakConfig
export const ssoInterceptorInstall = sso.ssoInterceptorInstall
export const installService = sso.installService
export const getKeycloak = () => sso.keycloak
export const keycloak = sso.keycloak
export const isPending = sso.isPending
export const loadPromise = sso.keycloakLoad
